import React from "react";
import PropTypes from "prop-types";
import Button from "components/Common/Button";
import DebouncedInput from "components/Common/DebouncedInput";
import InfoTooltip from "components/Common/InfoTooltip";
import colors from "stylesheets/utilities/colors.scss";
import GreetingPath from "./GreetingPath";

class GreetingPathList extends React.Component {
  constructor(props) {
    super(props);

    this.handleNewPathKeyPress = this.props.handleNewPathKeyPress.bind(this);
  }

  render() {
    return (
      <div className="Greeting__path-list">
        <span className="Greeting__left-column__label">
          <label htmlFor="Greeting-URL-input">Paths</label>
          <InfoTooltip
            customClassName="Greeting__left-column__label--margin"
            blurb="Which pages should this Intro appear on? Please add a URL for each page below."
            iconDefault="QuestionCircle"
            iconClicked="QuestionCircleFilled"
            absolute
            inModal
          />
        </span>
        <div className="Greeting__content__input-container">
          <DebouncedInput
            id="Greeting-URL-input"
            autoComplete="off"
            autoCorrect="off"
            customClassName="Greeting__content__input-container__input"
            placeholder="https://ada.support"
            value={this.props.path}
            debounceTime={50}
            onChange={this.props.updateNewPath}
            isInvalid={this.props.invalid}
            onKeyPress={this.handleNewPathKeyPress}
            forceValueRefresh
          />
          <div className="Greeting__content__input-container__button">
            {!this.props.invalid && (
              <Button
                onClick={() => this.props.addNewPath(this.props.path)}
                title="Add Path"
                icon="CircleAddAlternate"
                fillColor={!this.props.invalid ? colors.colorUIPrimary : colors.colorGrey4}
                clear
                disabled={this.props.path === ""}
              />
            )}
            {this.props.invalid && this.props.path !== "" && (
              <InfoTooltip
                customClassName="Tooltip--Warning"
                blurb={
                  this.props.pathInUse
                    ? "This path has already been used."
                    : "Please enter a partial URL or a whole URL."
                }
                iconDefault="Warning"
                fillColor={colors.colorUIWarn}
                link={{ title: "Learn More", href: "https://ada.support/articles/intros/" }}
                absolute
                inModal
              />
            )}
          </div>
        </div>
        {Boolean(this.props.getValue("paths")) && Boolean(this.props.getValue("paths").size) && (
          <div className="Greeting__paths">
            {this.props.getValue("paths").map((path, index) => (
              <GreetingPath
                key={path}
                index={index}
                path={path}
                customClassName={
                  this.props.getValue("invalidFields").contains(path)
                    ? "GreetingPath--invalid"
                    : ""
                }
                invalid={this.props.getValue("invalidFields").contains(path)}
                handlePathRemove={this.props.deletePath}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

GreetingPathList.propTypes = {
  path: PropTypes.string.isRequired,
  invalid: PropTypes.bool,
  updateNewPath: PropTypes.func.isRequired,
  handleNewPathKeyPress: PropTypes.func.isRequired,
  addNewPath: PropTypes.func.isRequired,
  getValue: PropTypes.func.isRequired,
  deletePath: PropTypes.func.isRequired
};

GreetingPathList.defaultProps = {
  invalid: false
};


export default GreetingPathList;
